// Types
import type { LocaleProps } from '@/types/config/locale'

const LocaleConfig: LocaleProps = {
	default: 'fa',
	list: ['fa', 'en']
}

export default LocaleConfig
